<template>
  <div class="modal-parent">
    <Loading
      v-model:active="loading"
      :can-cancel="true"
      :is-full-page="true"
      color="#669933"
      loader="spinner"
    />

    <section class="header">
      <div style="margin: 0 auto; width: 96%">
        <div class="header-content">
          <div class="header-content-right">
            <h5 class="modal-caption">Update PKC Settings</h5>

            <div class="logo-container">
              <img src="../../../assets/releaf-logo.png" alt="releaf-logo" />
            </div>
          </div>

          <div class="icons-container" @click="closeModal">
            <div
              class="x-container"
              style="cursor: pointer"
              @click="closeModal"
            >
              <img src="../../../assets/x-icon.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="border"></div>

    <section class="form-container">
      <form class="form-container-div">
        <TextInput
          placeholder="PKC_R/T P1"
          fieldName="pkc_selling_price_per_ton"
          :inputValue="pkcForm.pkc_selling_price_per_ton"
          @onInputChange="handleInputChange"
          :disabledValue="true"
        />

        <TextInput
          placeholder="PKC_SP"
          fieldName="pkc_selling_price"
          :inputValue="pkcForm.pkc_selling_price"
          @onInputChange="handleInputChange"
        />

        <TextInput
          placeholder="P2_DRY to PKC"
          fieldName="p2_dry_to_pkc_qty"
          :inputValue="pkcForm.p2_dry_to_pkc_qty"
          @onInputChange="handleInputChange"
        />

        <TextInput
          placeholder="No of PKO/T P1 Cracked"
          fieldName="no_of_pkc_per_ton_cracked"
          :inputValue="pkcForm.no_of_pkc_per_ton_cracked"
          @onInputChange="handleInputChange"
          :disabledValue="true"
        />

        <TextInput
          placeholder="Tonnes of P1 in 1T of PKO"
          fieldName="tons_of_p1_in_1t_of_pkc"
          :inputValue="pkcForm.tons_of_p1_in_1t_of_pkc"
          @onInputChange="handleInputChange"
          :disabledValue="true"
        />
      </form>
    </section>

    <div class="border"></div>

    <div class="button-container">
      <GreenButton
        label="Update"
        width="10.5rem"
        height="2.9rem"
        @click="updatePKC"
      />
    </div>
  </div>
</template>

<script>
import TextInput from "../../../components/form-inputs/text-input/TextInput.vue";
import GreenButton from "../../../components/buttons/green-button/GreenButton.vue";
import Loading from "vue-loading-overlay";
import { createToast } from "mosha-vue-toastify";

export default {
  name: "EditPKOModal",
  components: {
    TextInput,
    GreenButton,
    Loading,
  },

  data() {
    return {
      pkcForm: {
        pkc_selling_price_per_ton: this.pkc_seling_price_per_ton || "",
        pkc_selling_price: this.pkc_seling_price || "",
        p2_dry_to_pkc_qty: this.p2_dry_to_pkc_qy || "",
        no_of_pkc_per_ton_cracked: this.no_of_pkc_pr_ton_cracked || "",
        tons_of_p1_in_1t_of_pkc: this.tons_of_p1_in_ton_of_pkc || "",
      },
      loading: false,
    };
  },

  props: {
    p1_to_p2_dry_qty: {
      type: Number,
      required: true,
    },

    pkc_seling_price_per_ton: {
      type: String,
      required: true,
    },

    pkc_seling_price: {
      type: String,
      required: true,
    },

    p2_dry_to_pkc_qy: {
      type: String,
      required: true,
    },

    no_of_pkc_pr_ton_cracked: {
      type: String,
      required: true,
    },

    tons_of_p1_in_ton_of_pkc: {
      type: String,
      required: true,
    },
  },

  methods: {
    closeModal() {
      this.$emit("onCloseModal", false);
    },

    handleInputChange(obj) {
      this.pkcForm = {
        ...this.pkcForm,
        ...obj,
      };
    },

    async updatePKC() {
      this.loading = true;

      try {
        const {
          pkc_selling_price_per_ton,
          pkc_selling_price,
          p2_dry_to_pkc_qty,
          no_of_pkc_per_ton_cracked,
          tons_of_p1_in_1t_of_pkc,
        } = this.pkcForm;

        const payload = {
          pkc_selling_price_per_ton: Number(pkc_selling_price_per_ton),
          pkc_selling_price: Number(pkc_selling_price),
          p2_dry_to_pkc_qty: Number(p2_dry_to_pkc_qty),
          no_of_pkc_per_ton_cracked: Number(no_of_pkc_per_ton_cracked),
          tons_of_p1_in_1t_of_pkc: Number(tons_of_p1_in_1t_of_pkc),
        };

        const response = await this.$store.dispatch(
          "profitInput/updatePriceAtomSettings",
          payload
        );

        if (response.acknowledged) {
          this.loading = false;
          this.$emit('updatePKCEvent', this.pkcForm)

          createToast("PKC Settings Updated Successfully", {
            type: "success",
            position: "top-right",
            timeout: 3000,
            onClose: () => {
            },
          });
        }
      } catch (error) {
        console.log(error);
        this.loading = false;

      }
    },
  },

  watch: {
    "pkcForm.p2_dry_to_pkc_qty": function (val) {
      this.pkcForm.no_of_pkc_per_ton_cracked = this.p1_to_p2_dry_qty * val;

      this.tons_of_p1_in_1t_of_pkc = 1 / this.pkcForm.no_of_pkc_per_ton_cracked;

      this.handleInputChange({
        no_of_pkc_per_ton_cracked: this.pkcForm.no_of_pkc_per_ton_cracked,
        tons_of_p1_in_1t_of_pkc: this.tons_of_p1_in_1t_of_pkc,
      });
    },

    "pkcForm.pkc_selling_price": function (val) {
      this.pkcForm.pkc_selling_price_per_ton =
        val * (1 / this.pkcForm.tons_of_p1_in_1t_of_pkc);

      this.handleInputChange({
        pkc_selling_price_per_ton: this.pkcForm.pkc_selling_price_per_ton,
      });
    },

    "pkcForm.tons_of_p1_in_1t_of_pkc": function (val) {
      this.pkcForm.pkc_selling_price_per_ton =
        this.pkcForm.pkc_selling_price * (1 / val);

      this.handleInputChange({
        pkc_selling_price_per_ton: this.pkcForm.pkc_selling_price_per_ton,
      });
    },
  },
};
</script>

<style scoped>
.modal-parent {
  height: 100%;
  background: #fff;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4rem;
}

.modal-caption {
  color: #232a34;
  font-weight: 700;
}

.logo-container {
  background-color: #232a34;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icons-container {
  display: flex;
  justify-content: space-between;
  /* border: 1px solid red; */
}

.x-container {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: #dcdbdb;
}

.border {
  margin-top: 10px;
  background: #fff;
  border-bottom: 1px solid #b3b3b3;
}

.form-container {
  height: 230px;
  overflow-y: scroll;
}

.form-container-div {
  margin: 5% auto;
  width: 65%;
  height: 70%;
}

.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}
</style>
